// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================================================
   JOB VIEW
=========================================================== */

.job-view{
    padding:25px;
    background:#f5f7fb;
    width:100%;
    height:800px;
    overflow-y:auto;
    scrollbar-width:none;
    -ms-overflow-style:none;
}

.job-view::-webkit-scrollbar{
    display:none;
}


/* ===========================================================
   LOADING
=========================================================== */

.job-view-loading{
    width:750px;
    height:800px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:20px;
    font-weight:600;
    color:#2563eb;
}


/* ===========================================================
   HEADER
=========================================================== */

.job-header{
    background:linear-gradient(135deg,#2563eb,#4f46e5);
    color:white;
    border-radius:20px;
    padding:30px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    box-shadow:0 15px 35px rgba(37,99,235,.25);
    margin-bottom:25px;
}

/* ===========================================================
   LEFT
=========================================================== */

.job-header-left{
    display:flex;
    align-items:center;
    gap:20px;
}

.job-avatar{
    width:80px;
    height:80px;
    border-radius:50%;
    background:rgba(255,255,255,.15);
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:34px;
    border:3px solid rgba(255,255,255,.2);
}

.job-header-left h1{
    margin:0;
    font-size:30px;
    font-weight:700;
}

.job-header-left p{
    display:flex;
    align-items:center;
    gap:8px;
    margin-top:8px;
    opacity:.95;
    font-size:15px;
}


/* ===========================================================
   RIGHT
=========================================================== */

.job-header-right{
    display:flex;
    flex-direction:column;
    align-items:flex-end;
    gap:15px;
}

.job-status{
    padding:9px 22px;
    border-radius:30px;
    font-weight:700;
    text-transform:capitalize;
    letter-spacing:.4px;
    background:white;
    color:#2563eb;
}


/* STATUS COLORS */

.job-status.Active{
    background:#dcfce7;
    color:#16a34a;
}

.job-status.Open{
    background:#dbeafe;
    color:#2563eb;
}

.job-status.Closed{
    background:#fee2e2;
    color:#dc2626;
}

.job-status.Hold{
    background:#fef3c7;
    color:#d97706;
}


.job-created{
    display:flex;
    align-items:center;
    gap:10px;
    font-size:15px;
    opacity:.95;
}

.job-created svg{
    font-size:18px;
}


/* ===========================================================
   OVERVIEW
=========================================================== */

.job-overview{
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(160px,1fr));
    gap:20px;
}

.overview-card{
    background:white;
    border-radius:18px;
    padding:22px;
    box-shadow:0 8px 25px rgba(0,0,0,.06);
    transition:.3s;
    cursor:pointer;
    border:1px solid #edf2f7;
}

.overview-card:hover{
    transform:translateY(-6px);
    box-shadow:0 15px 30px rgba(37,99,235,.18);
    border-color:#2563eb;
}

.overview-card label{
    display:block;
    color:#94a3b8;
    font-size:13px;
    margin-bottom:10px;
    text-transform:uppercase;
    letter-spacing:.5px;
}

.overview-card h3{
    margin:0;
    color:#1e293b;
    font-size:20px;
    font-weight:700;
}


/* ===========================================================
   RESPONSIVE
=========================================================== */

@media(max-width:768px){

.job-view{
    width:100%;
    padding:15px;
}

.job-header{
    flex-direction:column;
    align-items:flex-start;
    gap:25px;
}

.job-header-right{
    align-items:flex-start;
}

.job-overview{
    grid-template-columns:1fr;
}

}





/* ==========================================================
   JOB CARD
========================================================== */

.job-card{
    background:#fff;
    border-radius:18px;
    padding:24px;
    margin-top:25px;
    box-shadow:0 10px 30px rgba(0,0,0,.06);

}

.job-card-title{
    display:flex;
    align-items:center;
    gap:12px;
    margin-bottom:25px;
}

.job-card-title svg{
    color:#2563eb;
    font-size:22px;
}

.job-card-title h2{
    margin:0;
    color:#1e293b;
    font-size:22px;
}

.job-grid{
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
    gap:20px;
}

.job-info-box{
    display:flex;
    align-items:center;
    gap:18px;
    padding:18px;
    border:1px solid #edf2f7;
    border-radius:16px;
    transition:.3s;
    cursor:pointer;
    background:white;
}

.job-info-box:hover{
    transform:translateY(-4px);
    box-shadow:0 10px 25px rgba(37,99,235,.15);
}

.job-icon{
    width:55px;
    height:55px;
    border-radius:14px;
    display:flex;
    justify-content:center;
    align-items:center;
    color:white;
    font-size:22px;
}

.job-icon.blue{
    background:#2563eb;
}

.job-icon.green{
    background:#10b981;
}

.job-icon.orange{
    background:#f59e0b;
}

.job-icon.red{

    background:#ef4444;

}

.job-icon.purple{

    background:#7c3aed;

}

.job-icon.cyan{

    background:#06b6d4;

}

.job-info-box label{

    display:block;

    color:#94a3b8;

    font-size:13px;

    margin-bottom:5px;

}

.job-info-box h4{

    margin:0;

    color:#1e293b;

    font-size:17px;

}

/* =======================================
   INTERVIEW PROCESS
======================================= */

.interview-process-box{

    display:flex;

    flex-direction:column;

    gap:18px;

}

.process-item{

    display:flex;

    align-items:center;

    gap:18px;

    padding:18px;

    border-radius:16px;

    background:#f8fafc;

    border:1px solid #e5e7eb;

    transition:.3s;

}

.process-item:hover{

    transform:translateX(6px);

    box-shadow:0 12px 25px rgba(37,99,235,.12);

}

.process-number{

    width:50px;

    height:50px;

    border-radius:50%;

    background:linear-gradient(
        135deg,
        #2563eb,
        #4f46e5
    );

    color:white;

    display:flex;

    justify-content:center;

    align-items:center;

    font-size:20px;

    font-weight:bold;

}

.process-content{

    flex:1 1;

}

.process-content h4{

    margin:0;

    color:#1e293b;

}

.process-content span{

    color:#64748b;

    font-size:13px;

}

.no-process{

    text-align:center;

    padding:35px;

    color:#64748b;

    background:#f8fafc;

    border-radius:14px;

}

/* ===========================================
   JOB DESCRIPTION
=========================================== */

.job-description-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin-bottom:20px;

}

.copy-btn{

    border:none;

    background:#2563eb;

    color:white;

    padding:10px 18px;

    border-radius:10px;

    cursor:pointer;

    display:flex;

    align-items:center;

    gap:8px;

    font-weight:600;

    transition:.3s;

}

.copy-btn:hover{

    background:#1d4ed8;

}

.job-description{

    background:#f8fafc;

    border-radius:14px;

    padding:22px;

    line-height:1.8;

    color:#334155;

    max-height:220px;

    overflow:hidden;

    white-space:pre-wrap;

    border:1px solid #e2e8f0;

}

.job-description.expanded{

    max-height:none;

}

.job-description-footer{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin-top:18px;

}

.job-description-footer span{

    color:#64748b;

    font-size:14px;

}

.expand-btn{

    border:none;

    background:none;

    color:#2563eb;

    cursor:pointer;

    font-weight:600;

}

.expand-btn:hover{

    text-decoration:underline;

}

.match-btn{

background:linear-gradient(135deg,#2563eb,#4f46e5);

color:white;

padding:14px 28px;

border:none;

border-radius:12px;

cursor:pointer;

font-weight:600;

display:flex;

align-items:center;

gap:10px;

font-size:15px;

}

.match-btn:hover{

transform:translateY(-3px);

}

.spin{

animation:spin 1s linear infinite;

}

@keyframes spin{

100%{

transform:rotate(360deg);

}

}

.matching-loader{

padding:40px;

text-align:center;

}

.ai-loader{

width:90px;

height:90px;

margin:auto;

border-radius:50%;

background:#2563eb;

color:white;

display:flex;

justify-content:center;

align-items:center;

font-size:38px;

animation:pulse 1.3s infinite;

}

@keyframes pulse{

50%{

transform:scale(1.1);

}

}

.match-table{

width:100%;

border-collapse:collapse;

margin-top:20px;

}

.match-table th{

background:#2563eb;

color:white;

padding:14px;

}

.match-table td{

padding:14px;

border-bottom:1px solid #eee;

}

.score{

background:#dcfce7;

color:#15803d;

padding:6px 12px;

border-radius:20px;

font-weight:700;

}

.matching-overlay{

position:fixed;

inset:0;

background:rgba(15,23,42,.72);

backdrop-filter:blur(5px);

display:flex;

justify-content:center;

align-items:center;

z-index:99999;

animation:fadeIn .3s ease;

}

.matching-box{

width:650px;

background:white;

border-radius:24px;

padding:35px;

box-shadow:0 30px 80px rgba(0,0,0,.3);

animation:popup .35s ease;

}

.ai-brain{

display:flex;

justify-content:center;

margin-bottom:20px;

}

.brain-circle{

width:95px;

height:95px;

border-radius:50%;

background:linear-gradient(135deg,#2563eb,#4f46e5);

display:flex;

justify-content:center;

align-items:center;

font-size:42px;

color:white;

animation:pulse 1.5s infinite;

box-shadow:0 0 30px rgba(37,99,235,.45);

}

.matching-box h2{

margin:0;

text-align:center;

color:#1e293b;

}

.matching-subtitle{

text-align:center;

color:#64748b;

margin:10px 0 30px;

}

.matching-steps{

height:300px;

overflow:hidden;

display:flex;

flex-direction:column;

gap:14px;

}

.matching-step{

opacity:.25;

transform:translateX(-25px);

transition:.45s;

font-size:15px;

display:flex;

align-items:center;

gap:12px;

font-weight:500;

color:#475569;

}

.matching-step.active{

opacity:1;

transform:translateX(0);

color:#2563eb;

font-weight:700;

}

.tick{

width:28px;

height:28px;

border-radius:50%;

background:#dbeafe;

display:flex;

justify-content:center;

align-items:center;

font-weight:bold;

}

.matching-progress{

margin-top:30px;

height:8px;

border-radius:20px;

background:#e2e8f0;

overflow:hidden;

}

.matching-progress-bar{

height:100%;

background:linear-gradient(90deg,#2563eb,#4f46e5);

transition:width .8s ease;

}

@keyframes pulse{

0%{

transform:scale(1);

}

50%{

transform:scale(1.08);

box-shadow:0 0 45px rgba(37,99,235,.65);

}

100%{

transform:scale(1);

}

}

@keyframes popup{

from{

transform:translateY(40px);

opacity:0;

}

to{

transform:translateY(0);

opacity:1;

}

}

@keyframes fadeIn{

from{

opacity:0;

}

to{

opacity:1;

}
}`, "",{"version":3,"sources":["webpack://./src/forms/JobView.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;;AAGA;;6DAE6D;;AAE7D;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;;AAGA;;6DAE6D;;AAE7D;IACI,kDAAkD;IAClD,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;;6DAE6D;;AAE7D;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;;AAGA;;6DAE6D;;AAE7D;IACI,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;;AAGA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;;AAGA;;6DAE6D;;AAE7D;IACI,YAAY;IACZ,wDAAwD;IACxD,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;;AAGA;;6DAE6D;;AAE7D;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;AAMA;;4DAE4D;;AAE5D;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sCAAsC;;AAE1C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,wDAAwD;IACxD,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;;IAEI,aAAa;;IAEb,aAAa;;IAEb,cAAc;;IAEd,iBAAiB;;AAErB;;AAEA;;IAEI,QAAQ;;IAER,aAAa;;IAEb,cAAc;;AAElB;;AAEA;;yCAEyC;;AAEzC;;IAEI,YAAY;;IAEZ,qBAAqB;;IAErB,QAAQ;;AAEZ;;AAEA;;IAEI,YAAY;;IAEZ,kBAAkB;;IAElB,QAAQ;;IAER,YAAY;;IAEZ,kBAAkB;;IAElB,kBAAkB;;IAElB,wBAAwB;;IAExB,cAAc;;AAElB;;AAEA;;IAEI,yBAAyB;;IAEzB,0CAA0C;;AAE9C;;AAEA;;IAEI,UAAU;;IAEV,WAAW;;IAEX,iBAAiB;;IAEjB;;;;KAIC;;IAED,WAAW;;IAEX,YAAY;;IAEZ,sBAAsB;;IAEtB,kBAAkB;;IAElB,cAAc;;IAEd,gBAAgB;;AAEpB;;AAEA;;IAEI,QAAM;;AAEV;;AAEA;;IAEI,QAAQ;;IAER,aAAa;;AAEjB;;AAEA;;IAEI,aAAa;;IAEb,cAAc;;AAElB;;AAEA;;IAEI,iBAAiB;;IAEjB,YAAY;;IAEZ,aAAa;;IAEb,kBAAkB;;IAElB,kBAAkB;;AAEtB;;AAEA;;6CAE6C;;AAE7C;;IAEI,YAAY;;IAEZ,6BAA6B;;IAE7B,kBAAkB;;IAElB,kBAAkB;;AAEtB;;AAEA;;IAEI,WAAW;;IAEX,kBAAkB;;IAElB,WAAW;;IAEX,iBAAiB;;IAEjB,kBAAkB;;IAElB,cAAc;;IAEd,YAAY;;IAEZ,kBAAkB;;IAElB,OAAO;;IAEP,eAAe;;IAEf,cAAc;;AAElB;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;;IAEI,kBAAkB;;IAElB,kBAAkB;;IAElB,YAAY;;IAEZ,eAAe;;IAEf,aAAa;;IAEb,gBAAgB;;IAEhB,eAAe;;IAEf,oBAAoB;;IAEpB,wBAAwB;;AAE5B;;AAEA;;IAEI,eAAe;;AAEnB;;AAEA;;IAEI,YAAY;;IAEZ,6BAA6B;;IAE7B,kBAAkB;;IAElB,eAAe;;AAEnB;;AAEA;;IAEI,aAAa;;IAEb,cAAc;;AAElB;;AAEA;;IAEI,WAAW;;IAEX,eAAe;;IAEf,aAAa;;IAEb,cAAc;;IAEd,eAAe;;AAEnB;;AAEA;;IAEI,yBAAyB;;AAE7B;;AAEA;;AAEA,kDAAkD;;AAElD,WAAW;;AAEX,iBAAiB;;AAEjB,WAAW;;AAEX,kBAAkB;;AAElB,cAAc;;AAEd,eAAe;;AAEf,YAAY;;AAEZ,kBAAkB;;AAElB,QAAQ;;AAER,cAAc;;AAEd;;AAEA;;AAEA,0BAA0B;;AAE1B;;AAEA;;AAEA,iCAAiC;;AAEjC;;AAEA;;AAEA;;AAEA,wBAAwB;;AAExB;;AAEA;;AAEA;;AAEA,YAAY;;AAEZ,iBAAiB;;AAEjB;;AAEA;;AAEA,UAAU;;AAEV,WAAW;;AAEX,WAAW;;AAEX,iBAAiB;;AAEjB,kBAAkB;;AAElB,WAAW;;AAEX,YAAY;;AAEZ,sBAAsB;;AAEtB,kBAAkB;;AAElB,cAAc;;AAEd,6BAA6B;;AAE7B;;AAEA;;AAEA;;AAEA,oBAAoB;;AAEpB;;AAEA;;AAEA;;AAEA,UAAU;;AAEV,wBAAwB;;AAExB,eAAe;;AAEf;;AAEA;;AAEA,kBAAkB;;AAElB,WAAW;;AAEX,YAAY;;AAEZ;;AAEA;;AAEA,YAAY;;AAEZ,4BAA4B;;AAE5B;;AAEA;;AAEA,kBAAkB;;AAElB,aAAa;;AAEb,gBAAgB;;AAEhB,kBAAkB;;AAElB,eAAe;;AAEf;;AAEA;;AAEA,cAAc;;AAEd,OAAO;;AAEP,6BAA6B;;AAE7B,yBAAyB;;AAEzB,YAAY;;AAEZ,sBAAsB;;AAEtB,kBAAkB;;AAElB,aAAa;;AAEb,yBAAyB;;AAEzB;;AAEA;;AAEA,WAAW;;AAEX,gBAAgB;;AAEhB,kBAAkB;;AAElB,YAAY;;AAEZ,qCAAqC;;AAErC,yBAAyB;;AAEzB;;AAEA;;AAEA,YAAY;;AAEZ,sBAAsB;;AAEtB,kBAAkB;;AAElB;;AAEA;;AAEA,UAAU;;AAEV,WAAW;;AAEX,iBAAiB;;AAEjB,kDAAkD;;AAElD,YAAY;;AAEZ,sBAAsB;;AAEtB,kBAAkB;;AAElB,cAAc;;AAEd,WAAW;;AAEX,6BAA6B;;AAE7B,uCAAuC;;AAEvC;;AAEA;;AAEA,QAAQ;;AAER,iBAAiB;;AAEjB,aAAa;;AAEb;;AAEA;;AAEA,iBAAiB;;AAEjB,aAAa;;AAEb,kBAAkB;;AAElB;;AAEA;;AAEA,YAAY;;AAEZ,eAAe;;AAEf,YAAY;;AAEZ,qBAAqB;;AAErB,QAAQ;;AAER;;AAEA;;AAEA,WAAW;;AAEX,2BAA2B;;AAE3B,eAAe;;AAEf,cAAc;;AAEd,YAAY;;AAEZ,kBAAkB;;AAElB,QAAQ;;AAER,eAAe;;AAEf,aAAa;;AAEb;;AAEA;;AAEA,SAAS;;AAET,uBAAuB;;AAEvB,aAAa;;AAEb,eAAe;;AAEf;;AAEA;;AAEA,UAAU;;AAEV,WAAW;;AAEX,iBAAiB;;AAEjB,kBAAkB;;AAElB,YAAY;;AAEZ,sBAAsB;;AAEtB,kBAAkB;;AAElB,gBAAgB;;AAEhB;;AAEA;;AAEA,eAAe;;AAEf,UAAU;;AAEV,kBAAkB;;AAElB,kBAAkB;;AAElB,eAAe;;AAEf;;AAEA;;AAEA,WAAW;;AAEX,iDAAiD;;AAEjD,yBAAyB;;AAEzB;;AAEA;;AAEA;;AAEA,kBAAkB;;AAElB;;AAEA;;AAEA,qBAAqB;;AAErB,uCAAuC;;AAEvC;;AAEA;;AAEA,kBAAkB;;AAElB;;AAEA;;AAEA;;AAEA;;AAEA,0BAA0B;;AAE1B,SAAS;;AAET;;AAEA;;AAEA,uBAAuB;;AAEvB,SAAS;;AAET;;AAEA;;AAEA;;AAEA;;AAEA,SAAS;;AAET;;AAEA;;AAEA,SAAS;;AAET;AACA","sourcesContent":["/* ===========================================================\r\n   JOB VIEW\r\n=========================================================== */\r\n\r\n.job-view{\r\n    padding:25px;\r\n    background:#f5f7fb;\r\n    width:100%;\r\n    height:800px;\r\n    overflow-y:auto;\r\n    scrollbar-width:none;\r\n    -ms-overflow-style:none;\r\n}\r\n\r\n.job-view::-webkit-scrollbar{\r\n    display:none;\r\n}\r\n\r\n\r\n/* ===========================================================\r\n   LOADING\r\n=========================================================== */\r\n\r\n.job-view-loading{\r\n    width:750px;\r\n    height:800px;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    font-size:20px;\r\n    font-weight:600;\r\n    color:#2563eb;\r\n}\r\n\r\n\r\n/* ===========================================================\r\n   HEADER\r\n=========================================================== */\r\n\r\n.job-header{\r\n    background:linear-gradient(135deg,#2563eb,#4f46e5);\r\n    color:white;\r\n    border-radius:20px;\r\n    padding:30px;\r\n    display:flex;\r\n    justify-content:space-between;\r\n    align-items:center;\r\n    box-shadow:0 15px 35px rgba(37,99,235,.25);\r\n    margin-bottom:25px;\r\n}\r\n\r\n/* ===========================================================\r\n   LEFT\r\n=========================================================== */\r\n\r\n.job-header-left{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:20px;\r\n}\r\n\r\n.job-avatar{\r\n    width:80px;\r\n    height:80px;\r\n    border-radius:50%;\r\n    background:rgba(255,255,255,.15);\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    font-size:34px;\r\n    border:3px solid rgba(255,255,255,.2);\r\n}\r\n\r\n.job-header-left h1{\r\n    margin:0;\r\n    font-size:30px;\r\n    font-weight:700;\r\n}\r\n\r\n.job-header-left p{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:8px;\r\n    margin-top:8px;\r\n    opacity:.95;\r\n    font-size:15px;\r\n}\r\n\r\n\r\n/* ===========================================================\r\n   RIGHT\r\n=========================================================== */\r\n\r\n.job-header-right{\r\n    display:flex;\r\n    flex-direction:column;\r\n    align-items:flex-end;\r\n    gap:15px;\r\n}\r\n\r\n.job-status{\r\n    padding:9px 22px;\r\n    border-radius:30px;\r\n    font-weight:700;\r\n    text-transform:capitalize;\r\n    letter-spacing:.4px;\r\n    background:white;\r\n    color:#2563eb;\r\n}\r\n\r\n\r\n/* STATUS COLORS */\r\n\r\n.job-status.Active{\r\n    background:#dcfce7;\r\n    color:#16a34a;\r\n}\r\n\r\n.job-status.Open{\r\n    background:#dbeafe;\r\n    color:#2563eb;\r\n}\r\n\r\n.job-status.Closed{\r\n    background:#fee2e2;\r\n    color:#dc2626;\r\n}\r\n\r\n.job-status.Hold{\r\n    background:#fef3c7;\r\n    color:#d97706;\r\n}\r\n\r\n\r\n.job-created{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:10px;\r\n    font-size:15px;\r\n    opacity:.95;\r\n}\r\n\r\n.job-created svg{\r\n    font-size:18px;\r\n}\r\n\r\n\r\n/* ===========================================================\r\n   OVERVIEW\r\n=========================================================== */\r\n\r\n.job-overview{\r\n    display:grid;\r\n    grid-template-columns:repeat(auto-fit,minmax(160px,1fr));\r\n    gap:20px;\r\n}\r\n\r\n.overview-card{\r\n    background:white;\r\n    border-radius:18px;\r\n    padding:22px;\r\n    box-shadow:0 8px 25px rgba(0,0,0,.06);\r\n    transition:.3s;\r\n    cursor:pointer;\r\n    border:1px solid #edf2f7;\r\n}\r\n\r\n.overview-card:hover{\r\n    transform:translateY(-6px);\r\n    box-shadow:0 15px 30px rgba(37,99,235,.18);\r\n    border-color:#2563eb;\r\n}\r\n\r\n.overview-card label{\r\n    display:block;\r\n    color:#94a3b8;\r\n    font-size:13px;\r\n    margin-bottom:10px;\r\n    text-transform:uppercase;\r\n    letter-spacing:.5px;\r\n}\r\n\r\n.overview-card h3{\r\n    margin:0;\r\n    color:#1e293b;\r\n    font-size:20px;\r\n    font-weight:700;\r\n}\r\n\r\n\r\n/* ===========================================================\r\n   RESPONSIVE\r\n=========================================================== */\r\n\r\n@media(max-width:768px){\r\n\r\n.job-view{\r\n    width:100%;\r\n    padding:15px;\r\n}\r\n\r\n.job-header{\r\n    flex-direction:column;\r\n    align-items:flex-start;\r\n    gap:25px;\r\n}\r\n\r\n.job-header-right{\r\n    align-items:flex-start;\r\n}\r\n\r\n.job-overview{\r\n    grid-template-columns:1fr;\r\n}\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* ==========================================================\r\n   JOB CARD\r\n========================================================== */\r\n\r\n.job-card{\r\n    background:#fff;\r\n    border-radius:18px;\r\n    padding:24px;\r\n    margin-top:25px;\r\n    box-shadow:0 10px 30px rgba(0,0,0,.06);\r\n\r\n}\r\n\r\n.job-card-title{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:12px;\r\n    margin-bottom:25px;\r\n}\r\n\r\n.job-card-title svg{\r\n    color:#2563eb;\r\n    font-size:22px;\r\n}\r\n\r\n.job-card-title h2{\r\n    margin:0;\r\n    color:#1e293b;\r\n    font-size:22px;\r\n}\r\n\r\n.job-grid{\r\n    display:grid;\r\n    grid-template-columns:repeat(auto-fit,minmax(250px,1fr));\r\n    gap:20px;\r\n}\r\n\r\n.job-info-box{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:18px;\r\n    padding:18px;\r\n    border:1px solid #edf2f7;\r\n    border-radius:16px;\r\n    transition:.3s;\r\n    cursor:pointer;\r\n    background:white;\r\n}\r\n\r\n.job-info-box:hover{\r\n    transform:translateY(-4px);\r\n    box-shadow:0 10px 25px rgba(37,99,235,.15);\r\n}\r\n\r\n.job-icon{\r\n    width:55px;\r\n    height:55px;\r\n    border-radius:14px;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    color:white;\r\n    font-size:22px;\r\n}\r\n\r\n.job-icon.blue{\r\n    background:#2563eb;\r\n}\r\n\r\n.job-icon.green{\r\n    background:#10b981;\r\n}\r\n\r\n.job-icon.orange{\r\n    background:#f59e0b;\r\n}\r\n\r\n.job-icon.red{\r\n\r\n    background:#ef4444;\r\n\r\n}\r\n\r\n.job-icon.purple{\r\n\r\n    background:#7c3aed;\r\n\r\n}\r\n\r\n.job-icon.cyan{\r\n\r\n    background:#06b6d4;\r\n\r\n}\r\n\r\n.job-info-box label{\r\n\r\n    display:block;\r\n\r\n    color:#94a3b8;\r\n\r\n    font-size:13px;\r\n\r\n    margin-bottom:5px;\r\n\r\n}\r\n\r\n.job-info-box h4{\r\n\r\n    margin:0;\r\n\r\n    color:#1e293b;\r\n\r\n    font-size:17px;\r\n\r\n}\r\n\r\n/* =======================================\r\n   INTERVIEW PROCESS\r\n======================================= */\r\n\r\n.interview-process-box{\r\n\r\n    display:flex;\r\n\r\n    flex-direction:column;\r\n\r\n    gap:18px;\r\n\r\n}\r\n\r\n.process-item{\r\n\r\n    display:flex;\r\n\r\n    align-items:center;\r\n\r\n    gap:18px;\r\n\r\n    padding:18px;\r\n\r\n    border-radius:16px;\r\n\r\n    background:#f8fafc;\r\n\r\n    border:1px solid #e5e7eb;\r\n\r\n    transition:.3s;\r\n\r\n}\r\n\r\n.process-item:hover{\r\n\r\n    transform:translateX(6px);\r\n\r\n    box-shadow:0 12px 25px rgba(37,99,235,.12);\r\n\r\n}\r\n\r\n.process-number{\r\n\r\n    width:50px;\r\n\r\n    height:50px;\r\n\r\n    border-radius:50%;\r\n\r\n    background:linear-gradient(\r\n        135deg,\r\n        #2563eb,\r\n        #4f46e5\r\n    );\r\n\r\n    color:white;\r\n\r\n    display:flex;\r\n\r\n    justify-content:center;\r\n\r\n    align-items:center;\r\n\r\n    font-size:20px;\r\n\r\n    font-weight:bold;\r\n\r\n}\r\n\r\n.process-content{\r\n\r\n    flex:1;\r\n\r\n}\r\n\r\n.process-content h4{\r\n\r\n    margin:0;\r\n\r\n    color:#1e293b;\r\n\r\n}\r\n\r\n.process-content span{\r\n\r\n    color:#64748b;\r\n\r\n    font-size:13px;\r\n\r\n}\r\n\r\n.no-process{\r\n\r\n    text-align:center;\r\n\r\n    padding:35px;\r\n\r\n    color:#64748b;\r\n\r\n    background:#f8fafc;\r\n\r\n    border-radius:14px;\r\n\r\n}\r\n\r\n/* ===========================================\r\n   JOB DESCRIPTION\r\n=========================================== */\r\n\r\n.job-description-header{\r\n\r\n    display:flex;\r\n\r\n    justify-content:space-between;\r\n\r\n    align-items:center;\r\n\r\n    margin-bottom:20px;\r\n\r\n}\r\n\r\n.copy-btn{\r\n\r\n    border:none;\r\n\r\n    background:#2563eb;\r\n\r\n    color:white;\r\n\r\n    padding:10px 18px;\r\n\r\n    border-radius:10px;\r\n\r\n    cursor:pointer;\r\n\r\n    display:flex;\r\n\r\n    align-items:center;\r\n\r\n    gap:8px;\r\n\r\n    font-weight:600;\r\n\r\n    transition:.3s;\r\n\r\n}\r\n\r\n.copy-btn:hover{\r\n\r\n    background:#1d4ed8;\r\n\r\n}\r\n\r\n.job-description{\r\n\r\n    background:#f8fafc;\r\n\r\n    border-radius:14px;\r\n\r\n    padding:22px;\r\n\r\n    line-height:1.8;\r\n\r\n    color:#334155;\r\n\r\n    max-height:220px;\r\n\r\n    overflow:hidden;\r\n\r\n    white-space:pre-wrap;\r\n\r\n    border:1px solid #e2e8f0;\r\n\r\n}\r\n\r\n.job-description.expanded{\r\n\r\n    max-height:none;\r\n\r\n}\r\n\r\n.job-description-footer{\r\n\r\n    display:flex;\r\n\r\n    justify-content:space-between;\r\n\r\n    align-items:center;\r\n\r\n    margin-top:18px;\r\n\r\n}\r\n\r\n.job-description-footer span{\r\n\r\n    color:#64748b;\r\n\r\n    font-size:14px;\r\n\r\n}\r\n\r\n.expand-btn{\r\n\r\n    border:none;\r\n\r\n    background:none;\r\n\r\n    color:#2563eb;\r\n\r\n    cursor:pointer;\r\n\r\n    font-weight:600;\r\n\r\n}\r\n\r\n.expand-btn:hover{\r\n\r\n    text-decoration:underline;\r\n\r\n}\r\n\r\n.match-btn{\r\n\r\nbackground:linear-gradient(135deg,#2563eb,#4f46e5);\r\n\r\ncolor:white;\r\n\r\npadding:14px 28px;\r\n\r\nborder:none;\r\n\r\nborder-radius:12px;\r\n\r\ncursor:pointer;\r\n\r\nfont-weight:600;\r\n\r\ndisplay:flex;\r\n\r\nalign-items:center;\r\n\r\ngap:10px;\r\n\r\nfont-size:15px;\r\n\r\n}\r\n\r\n.match-btn:hover{\r\n\r\ntransform:translateY(-3px);\r\n\r\n}\r\n\r\n.spin{\r\n\r\nanimation:spin 1s linear infinite;\r\n\r\n}\r\n\r\n@keyframes spin{\r\n\r\n100%{\r\n\r\ntransform:rotate(360deg);\r\n\r\n}\r\n\r\n}\r\n\r\n.matching-loader{\r\n\r\npadding:40px;\r\n\r\ntext-align:center;\r\n\r\n}\r\n\r\n.ai-loader{\r\n\r\nwidth:90px;\r\n\r\nheight:90px;\r\n\r\nmargin:auto;\r\n\r\nborder-radius:50%;\r\n\r\nbackground:#2563eb;\r\n\r\ncolor:white;\r\n\r\ndisplay:flex;\r\n\r\njustify-content:center;\r\n\r\nalign-items:center;\r\n\r\nfont-size:38px;\r\n\r\nanimation:pulse 1.3s infinite;\r\n\r\n}\r\n\r\n@keyframes pulse{\r\n\r\n50%{\r\n\r\ntransform:scale(1.1);\r\n\r\n}\r\n\r\n}\r\n\r\n.match-table{\r\n\r\nwidth:100%;\r\n\r\nborder-collapse:collapse;\r\n\r\nmargin-top:20px;\r\n\r\n}\r\n\r\n.match-table th{\r\n\r\nbackground:#2563eb;\r\n\r\ncolor:white;\r\n\r\npadding:14px;\r\n\r\n}\r\n\r\n.match-table td{\r\n\r\npadding:14px;\r\n\r\nborder-bottom:1px solid #eee;\r\n\r\n}\r\n\r\n.score{\r\n\r\nbackground:#dcfce7;\r\n\r\ncolor:#15803d;\r\n\r\npadding:6px 12px;\r\n\r\nborder-radius:20px;\r\n\r\nfont-weight:700;\r\n\r\n}\r\n\r\n.matching-overlay{\r\n\r\nposition:fixed;\r\n\r\ninset:0;\r\n\r\nbackground:rgba(15,23,42,.72);\r\n\r\nbackdrop-filter:blur(5px);\r\n\r\ndisplay:flex;\r\n\r\njustify-content:center;\r\n\r\nalign-items:center;\r\n\r\nz-index:99999;\r\n\r\nanimation:fadeIn .3s ease;\r\n\r\n}\r\n\r\n.matching-box{\r\n\r\nwidth:650px;\r\n\r\nbackground:white;\r\n\r\nborder-radius:24px;\r\n\r\npadding:35px;\r\n\r\nbox-shadow:0 30px 80px rgba(0,0,0,.3);\r\n\r\nanimation:popup .35s ease;\r\n\r\n}\r\n\r\n.ai-brain{\r\n\r\ndisplay:flex;\r\n\r\njustify-content:center;\r\n\r\nmargin-bottom:20px;\r\n\r\n}\r\n\r\n.brain-circle{\r\n\r\nwidth:95px;\r\n\r\nheight:95px;\r\n\r\nborder-radius:50%;\r\n\r\nbackground:linear-gradient(135deg,#2563eb,#4f46e5);\r\n\r\ndisplay:flex;\r\n\r\njustify-content:center;\r\n\r\nalign-items:center;\r\n\r\nfont-size:42px;\r\n\r\ncolor:white;\r\n\r\nanimation:pulse 1.5s infinite;\r\n\r\nbox-shadow:0 0 30px rgba(37,99,235,.45);\r\n\r\n}\r\n\r\n.matching-box h2{\r\n\r\nmargin:0;\r\n\r\ntext-align:center;\r\n\r\ncolor:#1e293b;\r\n\r\n}\r\n\r\n.matching-subtitle{\r\n\r\ntext-align:center;\r\n\r\ncolor:#64748b;\r\n\r\nmargin:10px 0 30px;\r\n\r\n}\r\n\r\n.matching-steps{\r\n\r\nheight:300px;\r\n\r\noverflow:hidden;\r\n\r\ndisplay:flex;\r\n\r\nflex-direction:column;\r\n\r\ngap:14px;\r\n\r\n}\r\n\r\n.matching-step{\r\n\r\nopacity:.25;\r\n\r\ntransform:translateX(-25px);\r\n\r\ntransition:.45s;\r\n\r\nfont-size:15px;\r\n\r\ndisplay:flex;\r\n\r\nalign-items:center;\r\n\r\ngap:12px;\r\n\r\nfont-weight:500;\r\n\r\ncolor:#475569;\r\n\r\n}\r\n\r\n.matching-step.active{\r\n\r\nopacity:1;\r\n\r\ntransform:translateX(0);\r\n\r\ncolor:#2563eb;\r\n\r\nfont-weight:700;\r\n\r\n}\r\n\r\n.tick{\r\n\r\nwidth:28px;\r\n\r\nheight:28px;\r\n\r\nborder-radius:50%;\r\n\r\nbackground:#dbeafe;\r\n\r\ndisplay:flex;\r\n\r\njustify-content:center;\r\n\r\nalign-items:center;\r\n\r\nfont-weight:bold;\r\n\r\n}\r\n\r\n.matching-progress{\r\n\r\nmargin-top:30px;\r\n\r\nheight:8px;\r\n\r\nborder-radius:20px;\r\n\r\nbackground:#e2e8f0;\r\n\r\noverflow:hidden;\r\n\r\n}\r\n\r\n.matching-progress-bar{\r\n\r\nheight:100%;\r\n\r\nbackground:linear-gradient(90deg,#2563eb,#4f46e5);\r\n\r\ntransition:width .8s ease;\r\n\r\n}\r\n\r\n@keyframes pulse{\r\n\r\n0%{\r\n\r\ntransform:scale(1);\r\n\r\n}\r\n\r\n50%{\r\n\r\ntransform:scale(1.08);\r\n\r\nbox-shadow:0 0 45px rgba(37,99,235,.65);\r\n\r\n}\r\n\r\n100%{\r\n\r\ntransform:scale(1);\r\n\r\n}\r\n\r\n}\r\n\r\n@keyframes popup{\r\n\r\nfrom{\r\n\r\ntransform:translateY(40px);\r\n\r\nopacity:0;\r\n\r\n}\r\n\r\nto{\r\n\r\ntransform:translateY(0);\r\n\r\nopacity:1;\r\n\r\n}\r\n\r\n}\r\n\r\n@keyframes fadeIn{\r\n\r\nfrom{\r\n\r\nopacity:0;\r\n\r\n}\r\n\r\nto{\r\n\r\nopacity:1;\r\n\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
